<div class="user-card" (click)="redirectTo()">
  <div class="badge" [ngClass]="{'inactif': !user.update_password}">
    <span>{{user.update_password ? 'ACTIF' : 'INACTIF'}}</span>
  </div>
  <div class="row">
    <span>Login</span>
    <p class="login">{{user.login}}</p>
  </div>
  <div class="row">
    <span>Email</span>
    <p>{{user.email}}</p>
  </div>
  <div class="row">
    <span>Nom</span>
    <p>{{user.nom}}</p>
  </div>
  <div class="row">
    <span>Prénom</span>
    <p>{{user.prenom}}</p>
  </div>

  <ion-icon name="create-outline"></ion-icon>
</div>
